import { BASE_URL } from "../App";
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card } from 'antd';
import { Button, Backdrop, CircularProgress, FormControlLabel, TextField, Radio, RadioGroup, Dialog, DialogTitle, DialogContent, DialogActions, Stack } from '@mui/material';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';


export default function ForgetPassword() {


    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = React.useState(false);
    const [Password, setPassword] = useState({ new_password: '', confirm_password: '' });
    const [ErrorMsg, setErrorMsg] = useState('');
    const [isValid, setIsValid] = useState(true);

    const LOGIN_ID = location.state && location.state.LOGIN_ID;
    const NAME = location.state && location.state.NAME;

    useEffect(() => {
        if (!LOGIN_ID || !NAME) {
            Swal.fire({
                icon: "warning",
                text: 'Unauthorized.!'
            });
            navigate('/');
        }
    }, [LOGIN_ID, NAME]);


    const validatePassword = (input) => {
        const hasUpperCase = /[A-Z]/.test(input);
        const hasLowerCase = /[a-z]/.test(input);
        const hasNumber = /[0-9]/.test(input);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(input);

        return hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
    };

    const UpdatePassword = () => {
        setOpen(true);

        if (Password.new_password !== Password.confirm_password) {
            setErrorMsg('Password And Confirm Password Not Macth.!');
            setIsValid(false);
            setOpen(false);
            return;
        }

        if (!validatePassword(Password.new_password)) {
            setErrorMsg('Password must contain at least one Uppercase, one Lowercase, one number, and one special character.');
            setIsValid(false);
            setOpen(false);
            return;
        }

        const data = {
            LOGINID: LOGIN_ID,
            Name: NAME,
            NewPassword: Password.new_password,
            ConfirmPassword: Password.confirm_password,
        }

        axios.post(BASE_URL + '/ResetPassword', data)
            .then(response => {
                if (response.status === 200) {
                    Swal.fire({
                        icon: "success",
                        text: response.data.message
                    });
                    navigate('/');
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: response.data.message
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message
                    });
                }
            }).finally(() => {
                setOpen(false);
            });

    }


    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className="m-4">
                <Card className="shadow bg-white rounded p-2">
                    <center><h3 style={{ fontWeight: '1000' }}><i>Reset Password</i></h3></center>
                    <hr />
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <TextField label="User ID" value={LOGIN_ID} size="small" fullWidth className="mb-3" readOnly disabled />
                        </div>
                        <div className="col-md-6 mb-3">
                            <TextField label="User Name" value={NAME} size="small" fullWidth className="mb-3" readOnly disabled />
                        </div>
                        <div className="col-md-6 mb-3">
                            <TextField
                                label="New Password"
                                size="small"
                                fullWidth
                                className="mb-3"
                                type="password"
                                value={Password.new_password}
                                onChange={(e) => {
                                    const input = e.target.value;
                                    const truncatedInput = input.slice(0, 15);
                                    setPassword({ ...Password, new_password: truncatedInput });
                                    setIsValid(true);
                                }}
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <TextField
                                label="Confirm Password"
                                size="small"
                                fullWidth
                                className="mb-3"
                                type="password"
                                value={Password.confirm_password}
                                onChange={(e) => {
                                    const input = e.target.value;
                                    const truncatedInput = input.slice(0, 15);
                                    setPassword({ ...Password, confirm_password: truncatedInput });
                                    setIsValid(true);
                                }} />
                        </div>
                    </div>
                    {!isValid && (
                        <>
                            <center><b style={{ color: 'red' }} className="mb-3">{ErrorMsg}</b></center><br />
                        </>
                    )}
                    <Button
                        fullWidth
                        variant="contained"
                        className="mb-3"
                        onClick={UpdatePassword}
                    >
                        <b>Update Password</b>
                    </Button>
                </Card>
            </div>
        </>
    );
}